import { render, staticRenderFns } from "./ModalMediaBank.vue?vue&type=template&id=4ef6de95&"
import script from "./ModalMediaBank.vue?vue&type=script&lang=js&"
export * from "./ModalMediaBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports